import { memo } from 'react';
import GlobalSearchButton from '@/components/global-search/GlobalSearchButton';
import { useOptionalGlobalSearchContext } from '@/contexts/GlobalSearchContext';
import usePosthogTracking from '@/hooks/usePosthogTracking';

function UnmemoizedGlobalSearch({ isCollapse }: { isCollapse: boolean }) {
  const { trackEvent } = usePosthogTracking();
  const context = useOptionalGlobalSearchContext();

  // During auth loading, NavBar renders before GlobalSearchProvider is mounted
  if (!context) return null;

  return (
    <GlobalSearchButton
      isCollapse={isCollapse}
      onClick={() => {
        trackEvent('GLOBAL_SEARCH_OPENED');
        context.send({ type: 'OPEN' });
      }}
    />
  );
}

export const MemoizedGlobalSearch = memo(UnmemoizedGlobalSearch);
